import { render, staticRenderFns } from "./AnalyticSpendingCard.vue?vue&type=template&id=70d3579f&scoped=true&"
import script from "./AnalyticSpendingCard.vue?vue&type=script&lang=js&"
export * from "./AnalyticSpendingCard.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticSpendingCard.vue?vue&type=style&index=0&id=70d3579f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3579f",
  null
  
)

export default component.exports